export const switzerlandProgram = {
  programKey: 'szwajcaria-koleja-przez-alpy',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Szwajcaria koleją przez Alpy',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Szwajcaria:',
  stickySubtitle: 'Koleją przez Alpy',

  pageUrl:
    'https://coolturystki.pl/wycieczki/szwajcaria-koleja-przez-alpy',

  /*
   * Informacje marketingowe dla przyszłego katalogu i rekomendacji.
   * Nie pochodzą z API Vakanzy i można je bezpiecznie edytować ręcznie.
   */
  catalog: {
    image:
      'https://coolturystki.pl/lib/wyfaqa/szwajcaria-linia-albula-wiadukt-landwasser-msvk0gtb.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/szwajcaria-linia-albula-wiadukt-landwasser-msvk0gtb.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Szwajcaria'],
    categories: [],
    travelStyles: ['Wyjazd objazdowy'],
    catalogPublishedAt: '2026-08-18',
  },

  /*
   * Każdy termin jest osobnym wyjazdem w Vakanzie.
   */
  tripIds: [8, 9],

  /*
   * Dane, których obecnie nie dostarcza API Vakanzy.
   * Są łączone z terminami według ich ID.
   */
  termDetails: {
    '8': {
      pilotId: 'rafal',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      priceNote:
        'Cena przedsprzedażowa obowiązuje do 14 sierpnia.',
      priceNotePrice: 5190,

      /* Treści rozwijane, które mogą być inne dla każdego terminu. */
      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa leci z Lotniska Chopina w Warszawie (WAW) na lotnisko Zurych-Kloten (ZRH). Możliwe jest również dołączenie do grupy innym połączeniem.',
        },
        hotel: {
          title: 'Hotel 4★ w Zurychu',
          description:
            'W dzielnicy Zürich-West, blisko komunikacji miejskiej, pokoje 2-osobowe i śniadania w formie bufetu.',
        },
      },
    },

    '9': {
      pilotId: 'rafal',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      priceNote:
        'Cena przedsprzedażowa obowiązuje do 14 sierpnia.',
      priceNotePrice: 5190,

      /* Treści rozwijane, które mogą być inne dla każdego terminu. */
      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa leci z Lotniska Chopina w Warszawie (WAW) na lotnisko Zurych-Kloten (ZRH). Możliwe jest również dołączenie do grupy innym połączeniem.',
        },
        hotel: {
          title: 'Hotel 3★ w Zurychu',
          description:
            'Przy Goldbrunnenplatz, z dogodnym dojazdem do centrum, pokoje 2-osobowe i śniadania w formie bufetu.',
        },
      },
    },
  },
}
